import { defineMessages } from 'react-intl';

type MessageKeys = 'removeFromFavouritesLabel' | 'addToFavouritesLabel';

const message: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> =
	defineMessages({
		removeFromFavouritesLabel: {
			id: 'ai-mate.menu-item.remove-from-favourites-label',
			defaultMessage: 'Remove {agentName} from favourites',
			description:
				'Button label for removing an agent from favourites. The {agentName} placeholder is replaced with the agent name for unique accessible labels.',
		},
		addToFavouritesLabel: {
			id: 'ai-mate.menu-item.add-to-favourites-label',
			defaultMessage: 'Add {agentName} to favourites',
			description:
				'Button label for adding an agent to favourites. The {agentName} placeholder is replaced with the agent name for unique accessible labels.',
		},
	});

export default message;
